export default __webpack_public_path__ + "static/media/exit-modal-flex-plus-2x.7ba25817.png";